import Vue from 'vue';
import Vuex from 'vuex';

import app from './app/app.store';
import companies from '@/pages/company/company.store';
import rentals from '@/pages/rentals/rentals.store';
import users from '@/store/user/user.store';
import shareNowPass from '@/store/share-now-pass/share-now-pass.store';
import notifications from '@/components/global/notification/notification.store';
import driverManagement from '@/pages/driver-management/driver-management.store';
import migration from '@/pages/migration/migration.store';
import costCenters from '@/pages/cost-centers/cost-centers.store';
import companyRegistration from '@/pages/create-account-beta/company-registration.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    companies,
    companyRegistration,
    rentals,
    users,
    notifications,
    driverManagement,
    migration,
    costCenters,
    shareNowPass,
  },
});
